// About.js

import React from 'react';

export const About = () => {
    return (
        <div className="container my-5">
            <hr/>
            <p>This is a note-taking webapp created using React JS. Developed by Keval Sanghani.</p>
            {/* <ul>
                <li>Notes data is stored in browser localstorage and hence available across sessions.</li>
                <li>This site is hosted with Continuous Deployment through Git.</li>
            </ul> */}
            <hr/>
        </div>
    )
}
